import { useState } from "react";
import { tickerItems, navChannels } from "@/mocks/chigua";

export default function TopBar() {
  const [open, setOpen] = useState(false);

  const go = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className="sticky top-0 z-50 w-full">
      {/* 更新条压顶 */}
      <div className="bg-ink text-cream">
        <div className="mx-auto flex w-full max-w-7xl items-center gap-4 px-4 md:px-6">
          <span className="flex shrink-0 items-center gap-2 py-2 text-xs font-bold tracking-wider">
            <i className="ri-flashlight-line text-amber" />
            实时更新
          </span>
          <div className="ticker-wrap relative flex-1 overflow-hidden py-2">
            <div className="flex w-max animate-marquee gap-12 whitespace-nowrap">
              {[...tickerItems, ...tickerItems].map((t, i) => (
                <span key={i} className="flex items-center gap-2 text-xs text-cream/80">
                  <i className="ri-arrow-right-up-line text-ember" />
                  {t}
                </span>
              ))}
            </div>
          </div>
          <button
            type="button"
            onClick={() => go("trend")}
            className="hidden shrink-0 items-center gap-2 rounded-full bg-amber px-3 py-1.5 text-xs font-bold text-ink transition hover:bg-peach sm:flex"
          >
            传播节奏
            <i className="ri-fire-line" />
          </button>
        </div>
      </div>

      {/* 运营壳导航 */}
      <div className="border-b border-sand/70 bg-paper/90 backdrop-blur">
        <div className="mx-auto flex w-full max-w-7xl items-center justify-between gap-4 px-4 py-3 md:px-6">
          <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-ember text-cream">
              <i className="ri-emotion-happy-line text-lg" />
            </span>
            <span className="font-display-x text-2xl font-black tracking-wide">98吃瓜</span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {navChannels.map((c) => (
              <button
                key={c.id}
                type="button"
                onClick={() => go(c.id)}
                className="flex items-center gap-1.5 rounded-full px-3.5 py-2 text-sm font-medium text-ink/75 transition hover:bg-peach hover:text-ember"
              >
                <i className={`${c.icon} text-base`} />
                {c.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => go("shots")}
              className="hidden items-center gap-2 whitespace-nowrap rounded-full border border-ember/30 bg-cream px-4 py-2 text-sm font-semibold text-ember transition hover:bg-peach md:flex"
            >
              <i className="ri-download-cloud-2-line" />
              取素材
            </button>
            <button
              type="button"
              onClick={() => setOpen(!open)}
              className="flex h-10 w-10 items-center justify-center rounded-full bg-sand text-ink lg:hidden"
              aria-label="菜单"
            >
              <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
            </button>
          </div>
        </div>

        {open && (
          <nav className="border-t border-sand/60 bg-paper px-4 py-3 lg:hidden">
            <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
              {navChannels.map((c) => (
                <button
                  key={c.id}
                  type="button"
                  onClick={() => {
                    go(c.id);
                    setOpen(false);
                  }}
                  className="flex items-center gap-2 rounded-lg bg-cream px-3 py-2.5 text-sm font-medium text-ink transition hover:bg-peach"
                >
                  <i className={`${c.icon} text-ember`} />
                  {c.label}
                </button>
              ))}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}